module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vendo4-ff3dcfb5b9da4bad5a84245cecdc9a05.jpg";